import { Configuration, LogLevel } from "@azure/msal-browser";

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID || "";
const tenantId = import.meta.env.VITE_AZURE_TENANT_ID || "organizations";

if (!clientId && import.meta.env.DEV) {
  throw new Error(
    "[MSAL] VITE_AZURE_CLIENT_ID is not set. " +
      "Copy frontend/.env.example to frontend/.env.local and fill in real values.",
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_REDIRECT_URI || window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: import.meta.env.DEV ? LogLevel.Warning : LogLevel.Error,
      piiLoggingEnabled: false,
    },
  },
};

export const graphScopes = [
  "openid",
  "profile",
  "email",
  "offline_access",
  "User.Read",
  "Files.Read.All",
  "Sites.Read.All",
  "Mail.Read",
  "Chat.Read",
  "ChannelMessage.Read.All",
  "Calendars.Read",
  "OnlineMeetings.ReadWrite",
  "OnlineMeetingTranscript.Read.All",
  "OnlineMeetingAiInsight.Read.All",
  "CallTranscripts.Read.All",
  "Team.ReadBasic.All",
  "Channel.ReadBasic.All",
  "People.Read",
];

export const loginRequest = {
  scopes: graphScopes,
};

export const tokenRequest = {
  scopes: graphScopes,
};
